import {
  ConsciousnessLabelType,
  ConsciousnessUrineValueType,
  UrineLabelType,
  VitalMappingsType,
} from './types'
import { getConsciousnessValue, getUrineValue, getVitalValue } from './util'

export const VITAL_RANGES = {
  RESPIRATORY_RATE: {
    RANGES: [
      'UPPER_MET',
      'UPPER_DANGER',
      'UPPER_AT_RISK',
      'UPPER_WARNING',
      'NORMAL',
      'LOWER_DANGER',
      'LOWER_MET',
    ],
    UPPER_MET: {
      min: 37,
      max: 40,
      banded_min: 7,
      banded_max: 8,
      color: '#9966ff',
      chart_value: 7,
    },
    UPPER_DANGER: {
      min: 36,
      max: 37,
      banded_min: 6,
      banded_max: 7,
      color: '#ff9933',
      chart_value: 6,
    },
    UPPER_AT_RISK: {
      min: 31,
      max: 35,
      banded_min: 5,
      banded_max: 6,
      color: '#ffcc66',
      chart_value: 5,
    },
    UPPER_WARNING: {
      min: 21,
      max: 30,
      banded_min: 4,
      banded_max: 5,
      color: '#ffff99',
      chart_value: 4,
    },
    NORMAL: {
      min: 9,
      max: 20,
      banded_min: 3,
      banded_max: 4,
      color: '#ffffff',
      chart_value: 3,
    },
    LOWER_DANGER: {
      min: 5,
      max: 8,
      banded_min: 2,
      banded_max: 3,
      color: '#ff9933',
      chart_value: 2,
    },
    LOWER_MET: {
      min: 0,
      max: 4,
      banded_min: 1,
      banded_max: 2,
      color: '#9966ff',
      chart_value: 1,
    },
  },

  O2_SATURATION: {
    RANGES: ['NORMAL', 'WARNING', 'AT_RISK', 'DANGER'],
    NORMAL: {
      min: 93,
      max: 100,
      banded_min: 4,
      banded_max: 5,
      color: '#ffffff',
      chart_value: 4,
    },
    WARNING: {
      min: 90,
      max: 92,
      banded_min: 3,
      banded_max: 4,
      color: '#ffff99',
      chart_value: 3,
    },
    AT_RISK: {
      min: 85,
      max: 89,
      banded_min: 2,
      banded_max: 3,
      color: '#ffcc66',
      chart_value: 2,
    },
    DANGER: {
      min: 0,
      max: 84,
      banded_min: 1,
      banded_max: 2,
      color: '#ff9933',
      chart_value: 1,
    },
  },

  PULSE_RATE: {
    RANGES: [
      'UPPER_MET',
      'UPPER_DANGER',
      'UPPER_AT_RISK',
      'UPPER_WARNING',
      'NORMAL',
      'LOWER_WARNING',
      'LOWER_MET',
    ],
    UPPER_MET: {
      min: 140,
      max: 200,
      banded_min: 7,
      banded_max: 8,
      color: '#9966ff',
      chart_value: 7,
    },
    UPPER_DANGER: {
      min: 130,
      max: 139,
      banded_min: 6,
      banded_max: 7,
      color: '#ff9933',
      chart_value: 6,
    },
    UPPER_AT_RISK: {
      min: 110,
      max: 129,
      banded_min: 5,
      banded_max: 6,
      color: '#ffcc66',
      chart_value: 5,
    },
    UPPER_WARNING: {
      min: 100,
      max: 109,
      banded_min: 4,
      banded_max: 5,
      color: '#ffff99',
      chart_value: 4,
    },
    NORMAL: {
      min: 50,
      max: 99,
      banded_min: 3,
      banded_max: 4,
      color: '#ffffff',
      chart_value: 3,
    },
    LOWER_WARNING: {
      min: 40,
      max: 49,
      banded_min: 2,
      banded_max: 3,
      color: '#ffff99',
      chart_value: 2,
    },
    LOWER_MET: {
      min: 30,
      max: 39,
      banded_min: 1,
      banded_max: 2,
      color: '#9966ff',
      chart_value: 1,
    },
  },

  TEMPERATURE: {
    RANGES: [
      'UPPER_AT_RISK',
      'UPPER_WARNING',
      'NORMAL',
      'LOWER_WARNING',
      'LOWER_AT_RISK',
      'LOWER_DANGER',
    ],
    UPPER_AT_RISK: {
      min: 38.6,
      max: 50,
      banded_min: 6,
      banded_max: 7,
      color: '#ffcc66',
      chart_value: 6,
    },
    UPPER_WARNING: {
      min: 38,
      max: 38.5,
      banded_min: 5,
      banded_max: 6,
      color: '#ffff99',
      chart_value: 5,
    },
    NORMAL: {
      min: 36.1,
      max: 37.9,
      banded_min: 4,
      banded_max: 5,
      color: '#ffffff',
      chart_value: 4,
    },
    LOWER_WARNING: {
      min: 35.1,
      max: 36,
      banded_min: 3,
      banded_max: 4,
      color: '#ffff99',
      chart_value: 3,
    },
    LOWER_AT_RISK: {
      min: 34.1,
      max: 35,
      banded_min: 2,
      banded_max: 3,
      color: '#ffcc66',
      chart_value: 2,
    },
    LOWER_DANGER: {
      min: 0,
      max: 34,
      banded_min: 1,
      banded_max: 2,
      color: '#ff9933',
      chart_value: 1,
    },
  },

  URINE: {
    RANGES: ['UPPER_WARNING', 'NORMAL', 'LOWER_AT_RISK', 'LOWER_DANGER'],
    UPPER_WARNING: {
      min: 800,
      max: 900,
      banded_min: 4,
      banded_max: 5,
      color: '#ffff99',
      chart_value: 4,
    },
    NORMAL: {
      min: 120,
      max: 800,
      banded_min: 3,
      banded_max: 4,
      color: '#ffffff',
      chart_value: 3,
    },
    LOWER_AT_RISK: {
      min: 80,
      max: 120,
      banded_min: 2,
      banded_max: 3,
      color: '#ffcc66',
      chart_value: 2,
    },
    LOWER_DANGER: {
      min: 0,
      max: 79,
      banded_min: 1,
      banded_max: 2,
      color: '#ff9933',
      chart_value: 1,
    },
  },

  CONSCIOUSNESS: {
    RANGES: ['NORMAL', 'LOWER_WARNING', 'LOWER_DANGER', 'LOWER_MET'],
    NORMAL: {
      min: 4,
      max: 5,
      banded_min: 4,
      banded_max: 5,
      color: '#ffffff',
      chart_value: 4,
    },
    LOWER_WARNING: {
      min: 3,
      max: 4,
      banded_min: 3,
      banded_max: 4,
      color: '#ffff99',
      chart_value: 3,
    },
    LOWER_DANGER: {
      min: 2,
      max: 3,
      banded_min: 2,
      banded_max: 3,
      color: '#ff9933',
      chart_value: 2,
    },
    LOWER_MET: {
      min: 1,
      max: 2,
      banded_min: 1,
      banded_max: 2,
      color: '#9966ff',
      chart_value: 1,
    },
  },

  PAIN: {
    RANGES: ['UPPER_MET', 'UPPER_DANGER', 'UPPER_WARNING', 'NORMAL'],
    UPPER_MET: {
      min: 7,
      max: 10,
      banded_min: 4,
      banded_max: 5,
      color: '#9966ff',
      chart_value: 4,
    },
    UPPER_DANGER: {
      min: 4,
      max: 7,
      banded_min: 3,
      banded_max: 4,
      color: '#ff9933',
      chart_value: 3,
    },
    UPPER_WARNING: {
      min: 1,
      max: 4,
      banded_min: 2,
      banded_max: 3,
      color: '#ffff99',
      chart_value: 2,
    },
    NORMAL: {
      min: 0,
      max: 1,
      banded_min: 1,
      banded_max: 2,
      color: '#ffffff',
      chart_value: 1,
    },
  },
} as const

export const URINE_MAPPING = {
  labels: {
    '<= 79': 1,
    '80-119': 2,
    '120-799': 3,
    '>= 800': 4,
  } satisfies Record<UrineLabelType, ConsciousnessUrineValueType>,
  values: {
    1: '<= 79',
    2: '80-119',
    3: '120-799',
    4: '>= 800',
  } satisfies Record<ConsciousnessUrineValueType, UrineLabelType>,
} as const

export const CONSCIOUSNESS_MAPPING = {
  labels: {
    Unconscious: 1,
    Pain: 2,
    Voice: 3,
    Alert: 4,
  } satisfies Record<ConsciousnessLabelType, ConsciousnessUrineValueType>,
  values: {
    1: 'Unconscious',
    2: 'Pain',
    3: 'Voice',
    4: 'Alert',
  } satisfies Record<ConsciousnessUrineValueType, ConsciousnessLabelType>,
} as const


export const DATA_TRANSFORM_Y = 0.5

export const VITAL_MAPPINGS:VitalMappingsType = {
  resp: {
    value: 'respiration',
    transform: (v: number) => getVitalValue('RESPIRATORY_RATE', v)
  },
  spo2: {
    value: 'o2Saturation',
    transform: (v: number) => getVitalValue('O2_SATURATION', v)
  },
  pr: {
    value: 'heartRate',
    transform: (v: number) => getVitalValue('PULSE_RATE', v)
  },
  temp: {
    value: 'temperature',
    transform: (v: number) => getVitalValue('TEMPERATURE', v)
  },
  dia: {
    value: 'dia',
    transform: (v: number) => v
  },
  sys: {
    value: 'sys',
    transform: (v: number) => v
  },
  urine: {
    value: 'fourHourUrineOutput',
    transform: (v: number) => getUrineValue(v.toString())
  },
  consc: {
    value: 'consciousness',
    transform: (v: number) => getConsciousnessValue(v.toString())
  },
  pain: {
    value: 'painValue',
    transform: (v: number) => getVitalValue('PAIN', v)
  }
};
